import {Expose, Type} from "class-transformer";
import Shop from "./Shop";
import Address from "./Address";
import Attachment from "./Attachment";
import * as pluralize from "pluralize";

export default class Booth extends Address implements Likable, Imageable {
    name: string;
    price: number;

    @Type(() => Attachment)
    images: Attachment[];

    @Expose({name: "workstation_count"})
    workstationCount: number;

    @Expose({name: "terms"})
    terms: string;

    @Expose({name: "is_negotiable"})
    isNegotiable: boolean;

    @Expose({name: "is_commissioned"})
    isCommissioned: boolean;

    @Expose({name: "primary_picture_url"})
    primaryPictureUrl: string;

    @Expose({name: "salon_id"})
    shopId: number;

    @Type(() => Shop)
    @Expose({name: "salon"})
    shop: Shop;

    //likes
    @Expose({name: "like_count"})
    likeCount: number;

    @Expose({name: "is_liked"})
    isLiked: boolean;

    toString(): string {
        return `${this.workstationCount} ${pluralize("Booth", this.workstationCount)} Available`;
    }

    paymentMethods(): string[] {
        let methods = [];
        if (this.isCommissioned) {
            methods.push("Commissioned");
        }
        if (this.isNegotiable) {
            methods.push("Negotiable");
        }

        return methods;
    }

    imageable(): Imageable {
        if (this.primaryPictureUrl)
            return this;
        else
            return this.shop;
    }

    isNew(): boolean {
        return this.id != 0;
    }
};

export const BoothTerms = {
    PER_HOUR: "Per Hour",
    PER_DAY: "Per Day",
    PER_WEEK: "Per Week",
    PER_MONTH: "Per Month"
};

export const BoothPaymentMethods = {
    NEGOTIABLE: "Negotiable",
    COMMISSION: "Commission"
};

export const initializeNewBoothShop = (shop?: Shop) => {
    let booth = new Booth();
    if (shop) {
        booth.shop = shop;
        booth.shopId = shop.id;
    }
    booth.terms = BoothTerms.PER_DAY;
    booth.isNegotiable = false;
    booth.isCommissioned = false;
    booth.price = 0;
    booth.workstationCount = 0;

    return booth;
};

export const boothToApiDict = (booth: Booth)  => {
    let data = {
        salon_id: booth.shopId,
        workstation_count: booth.workstationCount,
        price: booth.price,
        terms: booth.terms,
        // extra check since redux forms checkbox sets "" for false booleans
        is_negotiable:  booth.isNegotiable === true ,
        is_commissioned: booth.isCommissioned === true
    };

    if (booth.id && booth.id > 0) {
        data["id"] = booth.id;
    }

    return data;
};






// WEBPACK FOOTER //
// ./app/client/_data/models/Booth.ts